<template>
  <div class="Video">
    <video
      v-lazyload="{ callback: onLoaded }"
      class="Video-video"
      muted
      loop
      playsinline
      autoplay
    >
      <source :data-src="src" type="video/mp4" />
    </video>
    <base-image
      v-if="!isLoaded"
      size="cover"
      :src="placeholderSrc"
      class="Video-placeholder u-posFit"
    ></base-image>
  </div>
</template>

<script>
import BaseImage from "@/components/BaseImage.vue";

export default {
  components: {
    BaseImage,
  },
  props: {
    src: {
      type: String,
      required: true,
    },
    placeholderSrc: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoaded: false,
    };
  },
  methods: {
    onLoaded() {
      this.isLoaded = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.Video {
  width: 100%;
  height: 100%;
}

.Video-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.Video-placeholder {
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// BaseVideo.vue?48304353